import React, { useContext } from 'react';
import { Carousel } from 'src/elements/Carousel/Carousel';

import { HomeContext } from '../Home';

export default function BrandCarouselSection() {
    const { brandCarousel } = useContext(HomeContext);
    return <Carousel items={brandCarousel} mainTitle="Top Workwear Brands" moreBlocks isHomepageCarousel />;
}
